import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RotateCcw, Loader2 } from "lucide-react";

import { Button } from "../ui/button";
import AiCopilot from "../AiCopilot";
import TicketNotes from "../TicketNotes";
import CallButton from "../CallButton";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import TicketOptionsMenu from "../TicketOptionsMenu";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import AceitarTicketModal from "../AceitarTicketModal";

const TicketActionButtons = ({ ticket }) => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [aceitando, setAceitando] = useState(false);
	const { user } = useContext(AuthContext);

	const handleUpdateTicketStatus = async (e, status, userId) => {
		setLoading(true);
		try {
			const { data } = await api.put(`/tickets/${ticket.id}`, {
				status: status,
				userId: userId || null,
			});

			setLoading(false);
			if (status === "open") {
				navigate(`/tickets/${data.id}`);
			} else {
				navigate("/tickets");
			}
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
	};

	return (
		<div className="ml-auto flex shrink-0 items-center gap-1.5">
			<CallButton ticket={ticket} />
			<TicketNotes ticketId={ticket.id} />
			<AiCopilot
				ticketId={ticket.id}
				onUsarTexto={(texto) =>
					document.dispatchEvent(
						new CustomEvent("copilot:usar-texto", { detail: texto })
					)
				}
			/>
			{/* O menu sai de dentro do bloco de "open": pausar o robô e ajustar a
			    automação valem em qualquer situação, e é justamente na conversa
			    ainda AGUARDANDO que se quer calar o robô — antes de assumir. */}
			<TicketOptionsMenu ticket={ticket} />
			{ticket.status === "closed" && (
				<Button
					size="sm"
					variant="outline"
					disabled={loading}
					onClick={(e) => handleUpdateTicketStatus(e, "open", user?.id)}
				>
					{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <RotateCcw className="h-4 w-4" />}
					{i18n.t("messagesList.header.buttons.reopen")}
				</Button>
			)}
			{ticket.status === "open" && (
				<>
					<Button
						size="sm"
						variant="outline"
						disabled={loading}
						onClick={(e) => handleUpdateTicketStatus(e, "pending", null)}
					>
						{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <RotateCcw className="h-4 w-4" />}
						{i18n.t("messagesList.header.buttons.return")}
					</Button>
					<Button
						size="sm"
						disabled={loading}
						onClick={(e) => handleUpdateTicketStatus(e, "closed", user?.id)}
					>
						{loading && <Loader2 className="h-4 w-4 animate-spin" />}
						{i18n.t("messagesList.header.buttons.resolve")}
					</Button>
				</>
			)}
			{ticket.status === "pending" && (
				<>
					{/* Mesmo caminho do botão da lista: aceitar é o momento em que se
					    decide para qual setor a conversa vai. */}
					<AceitarTicketModal
						aberto={aceitando}
						aoFechar={() => setAceitando(false)}
						ticket={ticket}
						aoAceitar={() => navigate(`/tickets/${ticket.id}`)}
					/>
					<Button size="sm" disabled={loading} onClick={() => setAceitando(true)}>
						{loading && <Loader2 className="h-4 w-4 animate-spin" />}
						{i18n.t("messagesList.header.buttons.accept")}
					</Button>
				</>
			)}
		</div>
	);
};

export default TicketActionButtons;
